import {Component, Inject} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ApplicationEmploymentDTO} from '../../../models/application/ApplicationEmploymentDTO';
import {DateUtil} from '../../../../common/util/DateUtil';

enum Controls {
  StartDate = 'startDate',
  EndDate = 'endDate',
  IncomeBracketCategoryCode = 'incomeBracketCategoryCode',
  IncomeAmount = 'incomeAmount',
  EmploymentNumber = 'employmentNumber'
}

@Component({
  selector: 'app-employment-details-dialog',
  templateUrl: './employment-details-dialog.component.html',
  styleUrls: ['../../../../../../styles/global/_dialog-styles.scss']
})
export class EmploymentDetailsDialogComponent {
  readonly controls = Controls;
  readonly dateFormat = DateUtil.dateFormat;

  heading: string;
  employmentForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<EmploymentDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      applicationPersonId: number,
      employment?: ApplicationEmploymentDTO
    }
  ) {
    this.heading = data.employment ? 'Edit Employment Details' : 'Add Employment Details';
    this.initForm();
    if (data.employment) {
      this.setFormValues(data.employment);
    }
  }

  onSave(): void {
    if (this.employmentForm.valid) {
      const formValue = this.employmentForm.value;
      const employment: ApplicationEmploymentDTO = {
        ...this.data.employment,
        startDate: formValue[Controls.StartDate],
        endDate: formValue[Controls.EndDate],
        incomeBracketCategoryCode: formValue[Controls.IncomeBracketCategoryCode],
        incomeAmount: formValue[Controls.IncomeAmount],
        employmentNumber: formValue[Controls.EmploymentNumber]
      };

      this.dialogRef.close(employment);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  private initForm(): void {
    this.employmentForm = this.formBuilder.group({
      [Controls.EmploymentNumber]: ['', Validators.required],
      [Controls.IncomeAmount]: [null, [Validators.required, Validators.min(0)]],
      [Controls.IncomeBracketCategoryCode]: [''],
      [Controls.StartDate]: [null, Validators.required],
      [Controls.EndDate]: [null]
    });
  }

  private setFormValues(employment: ApplicationEmploymentDTO): void {
    this.employmentForm.patchValue({
      [Controls.EmploymentNumber]: employment.employmentNumber,
      [Controls.IncomeAmount]: employment.incomeAmount,
      [Controls.IncomeBracketCategoryCode]: employment.incomeBracketCategoryCode,
      [Controls.StartDate]: new Date(employment.startDate),
      [Controls.EndDate]: employment.endDate ? new Date(employment.endDate) : null
    });
  }
}
